import Backbone from 'backbone'
import _ from 'underscore'
import ContentViewTemplate from '../templates/content.tpl'
import PageImageModel from '../models/page-image'
import ContentHeaderView from './content-header'
import PageNavView from './page-nav'
import config from '../config'
import { loadView } from '../overrides'

const ContentView = Backbone.View.extend({
    el: '#current-view',
    initialize() {
        this.template = _.template(ContentViewTemplate)

        this.model.set('mode', 'page')
    },
    async render() {
        this.$el.html(this.template(this.model.toJSON()))

        const headerView = new ContentHeaderView({model: this.model})
        this.$("#header").append(headerView.render().el)

        const PageImageViewClass = await loadView('page-image')

        for (let index = 1; index <= this.model.get('items'); index++) {
            const pageImageModel = new PageImageModel({
                index: index,
                slug: config.get('slug'),
                image_prefix: this.model.get('image_prefix'),
                custom_widths: this.model.get('custom_widths'),
            })

            const pageImageView = new PageImageViewClass({model: pageImageModel})

            this.$('#sub-view').append(pageImageView.render().el)
        }

        // load page nave view
        const pageNaveView = new PageNavView({model: this.model})
        this.$('#page-nav').append(pageNaveView.render().el)

        return this
    }
})

export default ContentView
